import { Button } from "react-bootstrap"
import { useLogoutUserMutation } from "../../../../app/authApiSlice"

const Disabled = () => {
  const [logoutUser] = useLogoutUserMutation()

  const onClick = () => {
    logoutUser()
  }

  return (
    <>
      <h1 className="mb-4 fs-2 fw-semibold text-danger">Your account has been disabled</h1>
      <p className="mb-4"> Please contact the administrator for more details.</p>
      <Button
        className="mt-2 px-5 rounded-3"
        variant="dark"
        onClick={onClick}
      >
        Log Out
      </Button>
    </>
  )
}

export default Disabled